module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNzEuOTAxIiBoZWlnaHQ9IjQyNC4yNTQiIHZpZXdCb3g9IjAgMCAzNzEuOTAxIDQyNC4yNTQiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzc0NiIgZGF0YS1uYW1lPSLjg5HjgrkgMzc0NiIgZD0iTTUxNy4yMzIsMTI5My43OTJ2LTI4My4zbDM3MS45LTE0MC45NTV2MjgzLjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE3LjIzMSAtODY5LjUzNykiIGZpbGw9ImxpbWUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/green_372.svg
// module id = KXi4
// module chunks = 0